export const deepMergeProps = (obj1, obj2) => {
	// Create a new object that combines the properties of both input objects
	const merged = {
		...obj1,
		...obj2,
	};
	const keys = Object.keys(merged);
	// Loop through the properties of the merged object
	keys.forEach(key => {
		// Check if the property is an object
		if (typeof merged[key] === "object" && merged[key] !== null) {
			// If the property is an object, recursively merge the objects
			merged[key] = deepMergeProps(obj1[key] ? obj1[key] : {}, obj2[key] ? obj2[key] : {});
		}
	});

	return merged;
};

const isPlainObject = value =>
	typeof value === "object" && value !== null && [Object, undefined].includes(value.constructor);

const isEmptyObject = value =>
	isPlainObject(value) && Object.getOwnPropertyNames(value).length === 0;

const filter = (obj, processed = new Set()) => {
	// Preventing circular references
	if (processed.has(obj)) throw new TypeError("Cannot process Object with circular references");

	const result = {};
	processed.add(obj);

	Object.getOwnPropertyNames(obj).forEach(name => {
		const value = obj[name];
		const processedValue = isPlainObject(value) ? filter(value, processed) : value;

		if (processedValue == null || isEmptyObject(processedValue)) return;

		result[name] = processedValue;
	});

	return result;
};

const removeEmptyProps = obj => (isPlainObject(obj) ? filter(obj) : {});

export default removeEmptyProps;
